import RouteWithFeatureFlag from './RouteWithFeatureFlag';

export default RouteWithFeatureFlag;
